import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { Translation } from 'react-i18next';
import { Row, Col, Typography, Card, DatePicker } from 'antd';
import DashboardUpcomingEvents from '../../calendar/containers/DashboardUpcomingEventsContainer';
import DashboardCareHelpers from '../../careGuideHelpers/containers/DashboardCareHelpersContainer';
import DashboardRecommendedUtilities from '../../recommendedUtilities/containers/DashboardRecommendedUtilitiesContainer';
import Logger from '../../../../../lib/Logger';
import DailyLogs from '../../partnershipFormAnswers/containers/DailyLogsContainer';
import LoadingIcon from '../../../elements/components/LoadingIcon';
import DashboardResources from '../../resources/containers/DashboardResourcesContainer';
import useWindowDimensions from '../../../../../lib/WindowDimensions';
import DashboardEventInvitationsList from '../../calendar/containers/DashboardEventInvitationsListContainer';
import DashboardInvitationsList from '../../careGuideInvitations/containers/DashboardInvitationsListContainer';
import DashboardCareGuideInvitationsQuickList from '../../careGuideHelpers/containers/DashboardCareGuideInvitationsQuickListContainer';
import CareGuideInvitationForm from '../../careGuideInvitations/containers/CareGuideInvitationFormContainer';
import { Redirect } from 'react-router-dom';
import { pathTo } from '../../../Routes';
import {
  MixpanelTracker,
  mixpanelEventsEnum,
} from '../../../../../lib/Mixpanel';

const { Title } = Typography;
const { RangePicker } = DatePicker;

const DashboardDetailPartnership = ({
  careGuideId,
  partnershipId,
  partnership,
  page,
  limit,
  order,
  list,
  load,
  isLoading,
  careGuide,
  profileId,
  history,
  rct,
  showModal,
  checkOnboardingAnswer,
  ...props
}) => {
  const { width } = useWindowDimensions();
  const isSmall = width <= 576;
  const isMedium = (width) => 768 && width <= 992;

  const [page_recommended_utilities, setPageRecommendedUtilities] = useState(1);
  const [page_daily_logs, setPageDailyLogs] = useState(1);
  const [dates, setDates] = useState({});
  const [redirectTo, setRedirectTo] = useState(null);

  const trackerDashboardEvent = (eventMixpanel, params = {}) => {
    let isPartner = false;

    const isOwner =
      careGuide && careGuide.owner && careGuide.owner.profile
        ? careGuide.owner.profile.id === profileId
        : false;

    if (!isOwner) {
      const helper =
        careGuide && careGuide.helpers
          ? careGuide.helpers.find(
              (x) => x.profile && x.profile.id === profileId
            )
          : null;

      const role = helper ? helper.role : null;
      if (role in [4, 5]) {
        isPartner = true;
      }
    }

    MixpanelTracker.mixpanelTrack(eventMixpanel, {
      careGuideName: `${careGuide.first_name} ${careGuide.last_name}`,
      partnershipName: careGuide?.partnership?.name ?? 'No partnership',
      partnershipId: careGuide?.partnership?.id ?? 'No partnership',
      careGuideId: careGuide.id,
      isPartner: isPartner,
      ...params,
    });
  };

  const onChangeDateHandler = (dates) => {
    const params = {
      start: dates && dates[0] ? dates[0].format('YYYY-MM-DD') : '',
      end: dates && dates[1] ? dates[1].format('YYYY-MM-DD') : '',
    };
    setDates(params);

    trackerDashboardEvent(mixpanelEventsEnum.DASHBOARD.DAYLY_LOGS_CHANGE_DATE, {
      start: params.start,
      end: params.end,
    });
  };

  useEffect(() => {
    load(partnershipId, page, limit, order);
  }, [partnershipId, page, limit, order, load]);

  useEffect(() => {
    if (rct === null) {
      if (careGuide.owner.profile.id === profileId) {
        if (careGuide?.is_onboarding_registration === 0) {
          checkOnboardingAnswer(
            partnershipId,
            careGuideId,
            (
              success,
              cognitoFormId,
              cognitoFormKey,
              newUserRequirement,
              oldUserRequirement,
              isOldUser,
              id
            ) => {
              if (success && cognitoFormId && cognitoFormKey) {
                //showModal(cognitoFormId, cognitoFormKey);
                setRedirectTo(
                  pathTo('CognitoFormScreen', null, {
                    ctk: cognitoFormKey,
                    cti: cognitoFormId,
                    nwur: newUserRequirement,
                    cid: careGuideId,
                    cfi: id,
                    our: oldUserRequirement,
                    iou: isOldUser,
                  })
                );
              }
            }
          );
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rct]);

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <Translation>
      {(t) => (
        <>
          <Row
            gutter={16}
            style={{
              margin: isSmall ? '0' : isMedium ? '20px 10px 0' : '40px 20px 0',
            }}
          >
            <Col
              lg={{ span: 18, order: 1 }}
              md={{ span: 24, order: 2 }}
              sm={{ span: 24, order: 2 }}
              xs={{ span: 24, order: 2 }}
            >
              {isLoading ? (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <LoadingIcon />
                </div>
              ) : (
                list.map(
                  (x) =>
                    (x.type !== 2 ||
                      (x.type === 2 &&
                        partnership?.cognito_form_key !== null &&
                        partnership.cognito_form_key !== null)) && (
                      <Card bordered={false} className='section-card'>
                        <div>
                          <Row
                            justify='space-between'
                            style={{ width: '100%' }}
                          >
                            <Col>
                              <Title level={4}>
                                {t('dashboard_section_type_' + x.type)}
                              </Title>
                            </Col>
                            {x.type === 2 && (
                              <Col>
                                <RangePicker
                                  size='large'
                                  format='MM/DD/YYYY'
                                  onChange={onChangeDateHandler}
                                />
                              </Col>
                            )}
                          </Row>
                          <Row>
                            {x.type === 1 && (
                              <DashboardResources
                                trackerDashboardEvent={trackerDashboardEvent}
                                careGuideId={careGuideId}
                                partnershipId={partnershipId}
                              />
                            )}
                            {x.type === 2 && (
                              <DailyLogs
                                page_daily_logs={page_daily_logs}
                                setPageDailyLogs={setPageDailyLogs}
                                careGuideId={careGuideId}
                                partnershipId={partnershipId}
                                dates={dates}
                                trackerDashboardEvent={trackerDashboardEvent}
                              />
                            )}
                            {x.type === 3 && (
                              <DashboardRecommendedUtilities
                                page_recommended_utilities={
                                  page_recommended_utilities
                                }
                                setPageRecommendedUtilities={
                                  setPageRecommendedUtilities
                                }
                                careGuideId={careGuideId}
                                partnershipId={partnershipId}
                                trackerDashboardEvent={trackerDashboardEvent}
                              />
                            )}
                          </Row>
                        </div>
                      </Card>
                    )
                )
              )}
            </Col>

            <Col
              lg={{ span: 6, order: 2 }}
              md={{ span: 24, order: 1 }}
              sm={{ span: 24, order: 1 }}
              xs={{ span: 24, order: 1 }}
            >
              <DashboardInvitationsList
                page={1}
                limit={5}
                order={'invited_at.desc'}
                trackerDashboardEvent={trackerDashboardEvent}
              />

              <DashboardEventInvitationsList
                careGuideId={careGuideId}
                start={moment().format('YYYY-MM-DD')}
                page={1}
                limit={5}
                order={'start_at.asc'}
                trackerDashboardEvent={trackerDashboardEvent}
              />

              <DashboardUpcomingEvents
                careGuideId={careGuideId}
                start={moment().format('YYYY-MM-DD')}
                end={moment().add(1, 'Y').format('YYYY-MM-DD')}
                page={1}
                limit={3}
                order={'start_at.asc'}
                trackerDashboardEvent={trackerDashboardEvent}
              />
              <DashboardCareGuideInvitationsQuickList
                careGuideId={careGuideId}
                page={1}
                limit={5}
                order={'joined_at.asc'}
                trackerDashboardEvent={trackerDashboardEvent}
              />

              <DashboardCareHelpers
                careGuideId={careGuideId}
                page={1}
                limit={5}
                order={'joined_at.asc'}
                trackerDashboardEvent={trackerDashboardEvent}
              />
            </Col>
          </Row>
          <CareGuideInvitationForm
            careGuideId={careGuideId}
            trackerDashboardEvent={trackerDashboardEvent}
          />
        </>
      )}
    </Translation>
  );
};

export default DashboardDetailPartnership;

Logger.log('silly', `DashboardDetailPartnership loaded.`);
